import { resolveCDNDir } from '@gjensidige/se-content-helpers';
import { apiFetcher } from '@gjensidige/service-async';

import { WidgetProps } from '../interfaces/Types';

export class AppHelper {
  static AppTexts: any = {};
  static AppIllustrations: any = [];

  static getDefaultData = (): WidgetProps => {
    return {
      headerText: 'Se pris och köp din boKvar-försäkring',
      cprNumberLabel: 'Ditt personnummer',
      cprNumberPlaceHolder: 'ÅÅÅÅMMDDNNNN',
      cprInvalidMessage: 'Vänligen kontrollera personnumret.',
      minAgeErrorText:
        'För dig som är under 18 år, kontakta kundservice så hjälper vi dig.',
      maxAgeErrorText:
        'Du måste vara under 70 år för att kunna köpa den här försäkringen.',
      cprNumberHelpText:
        'Vi behöver ditt personnummer för att kunna ge dig rätt pris. Personnumret ger oss bland annat uppgifter om var du bor och din ålder.',
      calculateBtnLabel: 'Identifiera dig och se ditt pris',
      footerMessage: '',
      personalDataHandlingInfoLinkText:
        'Läs mer om vår hantering av dina personuppgifter',
      personalDataHandlinkUrl: '/om-oss/gdpr',
      imageInfo: {
        image: 'youngmancomputer_simple.jpg',
        smallScreenImage: 'youngmancomputer_simple.jpg',
        imageAltText: ''
      }
    };
  };

  static checkLoginStatus = async () => {
    let isLoggedIn = false;
    const response: any = await apiFetcher.getJson(
      '/api-tools/v1/open/auth-level'
    );

    if (response.isOk()) {
      if (response.value && !AppHelper.isEmptyObject(response.value)) {
        const responseObj = response.value;
        isLoggedIn = parseInt(responseObj.value) > 0;
      }
    }
    return isLoggedIn;
  };

  static isEmptyObject = (obj: any) => Object.keys(obj).length === 0;

  static getEnonicContent = async (dataUrl: string, dataObject: any) => {
    let enonicData = {};
    if (dataObject) {
      try {
        enonicData = JSON.parse(dataObject);
      } catch {
        return enonicData;
      }
    } else {
      const response: any = await apiFetcher.postJson(dataUrl);
      if (response.isOk()) {
        if (response.value) {
          enonicData = response.value;
        }
      }
    }
    return enonicData;
  };
  static getImageCDNPath = (fileName: string) =>
    `${resolveCDNDir()}images/${fileName}`;

  static prepareData = (defaultData: WidgetProps, additionalData: any) => {
    return {
      headerText: additionalData?.headerText || defaultData.headerText,
      cprNumberLabel:
        additionalData?.cprNumberLabel || defaultData.cprNumberLabel,
      cprNumberPlaceHolder:
        additionalData?.cprNumberPlaceHolder ||
        defaultData.cprNumberPlaceHolder,
      cprNumberHelpText:
        additionalData?.cprNumberHelpText || defaultData.cprNumberHelpText,
      calculateBtnLabel:
        additionalData?.calculateBtnLabel || defaultData.calculateBtnLabel,
      cprInvalidMessage:
        additionalData?.cprInvalidMessage || defaultData.cprInvalidMessage,
      minAgeErrorText:
        additionalData?.minAgeErrorText || defaultData.minAgeErrorText,
      maxAgeErrorText:
        additionalData?.maxAgeErrorText || defaultData.maxAgeErrorText,
      footerMessage: additionalData?.footerMessage || defaultData.footerMessage,
      personalDataHandlingInfoLinkText:
        additionalData?.personalDataHandlingInfoLinkText ||
        defaultData.personalDataHandlingInfoLinkText,
      personalDataHandlinkUrl:
        additionalData?.personalDataHandlinkUrl ||
        defaultData.personalDataHandlinkUrl,
      imageInfo: {
        image: additionalData?.imageFileName || defaultData?.imageInfo?.image,
        smallScreenImage:
          additionalData?.smallScreenImageFileName ||
          defaultData?.imageInfo?.smallScreenImage,
        imageAltText: additionalData?.imageAltText || ''
      }
    };
  };
}
